import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import axios, { API, getErrorMessage } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (e) {
      toast.error(getErrorMessage(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F5F9F7] px-6 py-16">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-[0_8px_40px_rgba(15,107,79,0.08)] sm:p-10" data-testid="forgot-password-card">
        <Link to="/" className="mb-6 flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-[#0F6B4F] to-[#1677B8] text-white font-heading font-bold">K</div>
          <span className="font-heading text-lg font-bold text-[#1F2937]">KBIHU Muhammadiyah Surabaya</span>
        </Link>

        {sent ? (
          <div className="text-center" data-testid="forgot-password-success">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#0F6B4F]/10 text-[#0F6B4F]">
              <MailCheck className="h-7 w-7" />
            </div>
            <h1 className="mt-4 font-heading text-xl font-bold text-[#1F2937]">Periksa Email Anda</h1>
            <p className="mt-2 text-sm text-[#64748B]">
              Jika email terdaftar, tautan reset password telah dikirimkan. Silakan periksa kotak masuk Anda.
            </p>
            <Link to="/login" data-testid="forgot-password-success-back-login-link" className="mt-6 inline-block text-sm font-medium text-[#0F6B4F] hover:underline">
              Kembali ke halaman Masuk
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Lupa Password</h1>
            <p className="mt-1 text-sm text-[#64748B]">Masukkan email Anda untuk menerima tautan reset password.</p>
            <form onSubmit={handleSubmit} className="mt-8 space-y-5">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  data-testid="forgot-password-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-1.5 h-11 rounded-xl"
                />
              </div>
              <Button
                type="submit"
                disabled={loading}
                data-testid="forgot-password-submit-button"
                className="h-11 w-full rounded-full bg-gradient-to-r from-[#0F6B4F] to-[#1677B8] text-white hover:opacity-90"
              >
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Kirim Tautan Reset"}
              </Button>
            </form>
            <p className="mt-6 text-center text-sm text-[#64748B]">
              <Link to="/login" data-testid="forgot-password-back-login-link" className="font-medium text-[#0F6B4F] hover:underline">
                Kembali ke halaman Masuk
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
